import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
// import { useDemo } from '../../state/DemoContext'; // Unused import
import './sidebar.css';

const Sidebar = () => {
  // const { state } = useDemo(); // Unused
  const location = useLocation();

  // Determine current role based on route
  const isBorrowerDashboard = location.pathname === '/jo-xyz-demo/borrower-dashboard';
  const isLenderDashboard = location.pathname === '/jo-xyz-demo/lender-dashboard';
  
  // Role-specific navigation items
  const borrowerNavItems = [
    {
      path: '/jo-xyz-demo/borrower-dashboard',
      label: 'Dashboard',
      icon: '📊',
      description: 'Loan Overview'
    },
    {
      path: '/jo-xyz-demo/assets',
      label: 'My Assets',
      icon: '📦',
      description: 'Asset Management'
    },
    {
      path: '/jo-xyz-demo/offers',
      label: 'Available Offers',
      icon: '📋',
      description: 'Lending Opportunities'
    },
    {
      path: '/jo-xyz-demo/borrowing-base',
      label: 'Borrowing Base',
      icon: '📈',
      description: 'Credit Capacity'
    },
    {
      path: '/jo-xyz-demo/connect',
      label: 'Connect Systems',
      icon: '🔗',
      description: 'System Integration'
    }
  ];

  const lenderNavItems = [
    {
      path: '/jo-xyz-demo/lender-dashboard',
      label: 'Dashboard',
      icon: '📊',
      description: 'Portfolio Overview'
    },
    {
      path: '/jo-xyz-demo/marketplace',
      label: 'Marketplace',
      icon: '🏪',
      description: 'Investment Opportunities'
    },
    {
      path: '/jo-xyz-demo/investor',
      label: 'My Investments',
      icon: '💰',
      description: 'Portfolio Management'
    },
    {
      path: '/jo-xyz-demo/agents',
      label: 'AI Agents',
      icon: '🤖',
      description: 'Risk Analysis'
    },
    {
      path: '/jo-xyz-demo/connect',
      label: 'Connect Systems',
      icon: '🔗',
      description: 'System Integration'
    }
  ];

  // Default navigation for other pages
  const defaultNavItems = [
    {
      path: '/jo-xyz-demo/overview',
      label: 'Overview',
      icon: '📊',
      description: 'Dashboard & KPIs'
    },
    {
      path: '/jo-xyz-demo/connect',
      label: 'Connect Systems',
      icon: '🔗',
      description: 'System Integration'
    },
    {
      path: '/jo-xyz-demo/marketplace',
      label: 'Marketplace',
      icon: '🏪',
      description: 'Browse Listings'
    },
    {
      path: '/jo-xyz-demo/assets',
      label: 'Asset Registry',
      icon: '📦',
      description: 'Asset Management'
    },
    {
      path: '/jo-xyz-demo/borrowing-base',
      label: 'Borrowing Base',
      icon: '📈',
      description: 'Capacity & Funding'
    },
    {
      path: '/jo-xyz-demo/agents',
      label: 'AI Agents',
      icon: '🤖',
      description: 'Automation Tools'
    },
    {
      path: '/jo-xyz-demo/offers',
      label: 'Offers',
      icon: '📋',
      description: 'Lending Offers'
    }
  ];

  // Select appropriate navigation based on current route
  const navItems = isBorrowerDashboard ? borrowerNavItems : 
                   isLenderDashboard ? lenderNavItems : 
                   defaultNavItems;

  // Removed status logic - using only active highlighting

  return (
    <nav className="jo-xyz-demo-sidebar">
      <div className="jo-xyz-demo-sidebar__content">
        <ul className="jo-xyz-demo-sidebar__nav">
          {navItems.map((item) => (
            <li key={item.path} className="jo-xyz-demo-sidebar__item">
              <NavLink
                to={item.path}
                className="jo-xyz-demo-sidebar__link"
                activeClassName="jo-xyz-demo-sidebar__link--active"
              >
                <div className="jo-xyz-demo-sidebar__link-content">
                  <div className="jo-xyz-demo-sidebar__icon">
                    {item.icon}
                  </div>
                  <div className="jo-xyz-demo-sidebar__text">
                    <span className="jo-xyz-demo-sidebar__label">{item.label}</span>
                    <span className="jo-xyz-demo-sidebar__description">{item.description}</span>
                  </div>
                </div>
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="jo-xyz-demo-sidebar__footer">
          <div className="jo-xyz-demo-sidebar__user">
            <div className="user-profile">
              <div className="user-profile__avatar">
                <span className="user-profile__initials">Y</span>
              </div>
              <div className="user-profile__info">
                <div className="user-profile__name">Yas</div>
                <div className="user-profile__role">Asset Owner</div>
              </div>
            </div>

            <div className="user-stats">
              <div className="user-stat">
                <span className="user-stat__label">Credit Score</span>
                <span className="user-stat__value">780</span>
              </div>
              <div className="user-stat">
                <span className="user-stat__label">Active Loans</span>
                <span className="user-stat__value">2</span>
              </div>
              <div className="user-stat">
                <span className="user-stat__label">Available Credit</span>
                <span className="user-stat__value">$2.4M</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Sidebar;
